<template>
  <div>
    <kn-form-subtitle :title="`${actionTitle} tipo de movimiento de inventario`" />
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <kn-text-field
        v-model="movType.dato"
        class="mt-4"
        label="Nombre:"
        :rules="[rules.required]"
      />
      <kn-form-action-buttons
        class="mb-14"
        :small="true"
        :disableAccept="invalidFields"
        @accept="save"
        @cancel="clear"
      />
    </v-form>
    <kn-form-subtitle
      title="Listado de tipos de movimiento de inventario"
      divider-position="bottom"
    />
    <kn-list-with-actions
      :activeItems="activeOptions"
      @updateInline="updateInline"
      @deleteInline="deleteInline"
      @cancelInline="clearInline"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { validationFormMixin } from '@/mixins/validationFormMixin'
import { apiMixin } from '@/mixins/apiMixin'
export default {
  components: {
    KnFormSubtitle: () => import('@/components/KnFormSubtitle.vue'), 
    KnFormActionButtons: () => import('@/components/KnFormActionButtons.vue'),
    KnTextField: () => import('../inputs/KnTextField.vue'),
    KnListWithActions: () => import('./KnListWithActions.vue'),
  },
  mixins: [
    validationFormMixin,
    apiMixin
  ],
  data() {
    return {
      errors: [],
      valid: true,
      movType: {
        id: 'NA', // No asignado
        dato: null,
        id_autor: null,
        id_institucion_educativa: null
      },
      movementTypes: [],
      toUpdate: false,
    }
  },
  computed: {
    ...mapState(['institutionId', 'userData']),
    actionTitle() {
      return this.toUpdate ? 'Actualizar' : 'Crear'
    },
    activeOptions() {
      return this.movementTypes.filter(movType => movType.estatus_sistema === true)
    },
    invalidFields() {
      return this.objectHasNulls(this.movType)
    }
  },
  async created() {
    this.movType.id_autor = this.userData.id
    this.movType.id_institucion_educativa = this.institutionId
    this.movementTypes = await this.fetchResultsAll('inventarios', 'mv-movimiento-inventario-all')
  },
  methods: {
    async createOption() {
      try {
        const response = await this.postObj('/inventarios/crear-tipo-movimiento-inventario', {
          tipo_movimiento_inventario: this.movType.dato,
          id_autor: this.movType.id_autor
        })
        if (response.error) {
          this.errors.push(response.error)
        }
      } catch (error) {
        console.error('Error al intentar crear el tipo de movimiento de inventario', error)
        this.errors.push('Error al intentar crear el tipo de movimiento de inventario')
      }
    },
    async updateOption() {
      try {
        const response = await this.postObj('/inventarios/update-movimiento-inventario', {
          id: this.movType.id,
          movimiento_inventario: this.movType.dato
        })
        if (response.error) {
          this.errors.push(response.error)
        }
      } catch (error) {
        console.error('Error al intentar actualizar el tipo de movimiento de inventario', error);
      }
    },
    // Los deletes no eliminan los registros, cambian el estatus a False
    async deleteOption(movTypeId) {
      try {
        const response = await this.postObj('/inventarios/delete-movimiento-inventario', {
          id_movimiento_inventario: movTypeId
        })
        if (response.error) {
          this.errors.push(response.error)
        }
      } catch (error) {
        console.error('Error al intentar eliminar el tipo de movimiento de inventario', error);
      }
    },
    async save() {
      if (this.toUpdate) {
        await this.updateOption()
        this.toUpdate = false
      } else {
        await this.createOption()
        this.clear()
      }
      this.movementTypes = await this.fetchResultsAll('inventarios', 'mv-movimiento-inventario-all')
      this.clear()
    },
    clear() {
      this.movType = {
        id: 'NA', // No asignado
        dato: null,
        id_autor: this.userData.id
      }
      this.toUpdate = false
      this.$refs.form.resetValidation()
    },
    clearInline() {
      this.movType = {
        id: 'NA', // No asignado
        dato: null,
        id_autor: this.userData.id
      }
      this.toUpdate = false
      this.$refs.form.resetValidation()
    },
    async updateInline(item) {
      // console.log('updateInline item', item);
      this.movType = {...item}
      await this.updateOption()
      this.movementTypes = await this.fetchResultsAll('inventarios', 'mv-movimiento-inventario-all')
      this.clearInline()
    },
    async deleteInline(itemId) {
      await this.deleteOption(itemId)
      this.movementTypes = await this.fetchResultsAll('inventarios', 'mv-movimiento-inventario-all')
      this.clearInline()
    }
  },
}
</script>
